

import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { Link as domLink} from 'react-router-dom';
import {deepPurple, teal, yellow} from "@mui/material/colors";
import TelegramIcon from '@mui/icons-material/Telegram';
import EmailIcon from '@mui/icons-material/Email';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import HomeIcon from '@mui/icons-material/Home';
import Grid from "@mui/material/Grid";
import {IconButton} from "@mui/material";
import { FaDiscord } from 'react-icons/fa';

function Copyright() {
    return (
        <Typography variant="body2" color="text.secondary">
            {'Copyright © '}
            <Link color="inherit" href="https://www.digitalberd.com">
                DigitalBerd
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme({
    palette: {
        primary: deepPurple,
        secondary: teal
    },
});

export default function FooterComponent() {
    return (
        <ThemeProvider theme={defaultTheme}>

                <Box
                    component="footer"
                    sx={{
                        py: 0,
                        px: 2,
                        mt: 'auto',
                        minHeight: '15vh',
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'light'
                                ? deepPurple[200]
                                : deepPurple[800],
                    }}
                >
                    <Container maxWidth="sm">
                        <Box sx={{ maxWidth: 230, margin: '0 auto', padding: 2 }}>
                            <Grid container spacing={{ xs: 2, md: 3 }}>
                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}  >
                                    <IconButton component="a" href="https://hackathon.digitalberd.com">
                                        <HomeIcon />
                                    </IconButton>
                                </Grid>
                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}  >
                                    <IconButton component="a" href="https://t.me/+lK17NXxEwB0wYmYy" target="_blank">
                                        <TelegramIcon />
                                    </IconButton>
                                </Grid>
                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}  >
                                    <IconButton component="a" href="https://t.me/Alexander_Berdyshev" target="_blank">
                                        <PeopleOutlineIcon />
                                    </IconButton>
                                </Grid>
                                <Grid item xs={3} sm={3} md={3} lg={3} xl={3}  >
                                    <IconButton component="a" href="https://discord.gg/sPChRTTp" target="_blank">
                                        <FaDiscord size={32} color="#524864" />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            <Copyright />
                        </Box>

                    </Container>
                </Box>
        </ThemeProvider>
    );
}